module.exports = __webpack_public_path__ + "static/media/user (5).43c107d9.svg";